export default `
当您自行决定作出医疗行为之前，请先咨询医生的医疗建议。
使用平台时代表您已同意《免责申明》

<h2 style="text-align:center;margin-bottom: 0;">免责声明</h2>
1. 亮健康对于任何包含、经由或连接、下载或从任何与有关本服务所获得的任何内容、信息或广告，不声明或保证其正确性或可靠性；并且对于用户经本服务上的广告、展示而购买、取得的任何产品、信息或资料，亮健康不负保证责任。用户自行负担使用本服务的风险。

2. 亮健康有权但无义务，改善或更正本服务任何部分之任何疏漏、错误。

3. 用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，亮健康及其合作单位不承担责任。

4. 亮健康不保证（包括但不限于）：

（1）本服务适合用户的使用要求；

（2）本服务不受干扰，及时、安全、可靠或不出现错误，包括黑客入侵，网络中断，电信问题及其他不可抗力等;

（3）用户经由本服务取得的任何产品、服务或其他材料符合用户的期望；

5. 用户使用经由本服务下载的或取得的任何资料，其风险自行负担；因该使用而导致用户电脑系统损坏或资料流失，用户应负完全责任；

6. 基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，亮健康不承担任何直接、间接、附带、衍生或惩罚性的赔偿：

（1）本服务使用或无法使用；

（2）经由本服务购买或取得的任何产品、资料或服务；

（3）用户资料遭到未授权的使用或修改；

（4）其他与本服务相关的事宜。

7. 您在此同意独立承担因使用亮健康服务所导致的所有风险和后果，并同意亮健康平台不因此承担任何责任。

8. 因技术故障等不可抗事件影响到服务的正常运行的，亮健康及其合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，亮健康及其合作单位不承担责任。

9. 用户理解：本服务同其他互联网服务一样，用户在使用服务过程中会受到网络服务质量、社会环境、用户操作错误等诸多因素的影响，可能会受到各种问题的侵扰，比如他人利用用户的资料，进行现实生活中的骚扰。用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强对信息安全及使用者资料的保护意识，以免遭受损失和骚扰，因使用亮健康服务的风险由用户自行承担。

10. 用户理解：本服务涉及网络服务，可能会受到各个环节不稳定因素的影响，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。因前述情形导致用户不能发送、接受、阅读信息、或接发错信息，亮健康不承担任何责任。

11. 如因系统维护或升级等额而需暂停服务时，将事先公告。若因硬件故障或其他不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，亮健康不负任何责任。由于本服务的产品调整导致信息丢失和/或其他结果的，亮健康不承担任何责任。

12. 用户理解：使用本服务过程中存在可能面对来自他人的包括但不限于威胁性的、诽谤性的、令人反感的或其他非法的内容或行为和/或侵犯他人权利（包括但不限于知识产权）的匿名或冒名的信息的风险，用户须承担以上风险。亮健康和其合作公司对本服务不作任何明确或暗示的担保，包括但不限于有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的内容，对因此导致任何因用户不正当或非法使用亮健康服务产生的直接、间接、偶然、特殊及后续等侵犯第三人之合法权利的法律责任，亮健康不承担任何责任。

13. 亮健康平台对于发布在亮健康网站上的任何不正确或不准确的内容不承担任何责任，无论该等不准确是由亮健康服务的用户所造成的，还是由于亮健康服务所使用的或与亮健康服务相连接的任何设备或程序所造成的。

14. 用户在亮健康网站上创建和发布的档案文件可能包含指向其他网站的链接。亮健康平台对链接指向的网站上的内容、及其准确性或其所表达的观点不承担任何责任，并且亮健康平台不对其准确性或完整性进行调查、监控或检查。在亮健康服务中包含的任何链接指向的网站并不暗示亮健康平台已经批准或认可所链接的网站。在访问这些第三方网站时，您需要自己承担相关的风险。

15.用户在亮健康APP平台观看与健康疾病药品类科普视频，用户需要自行决定治疗方式和所用药品，亮健康建议用户作出任何医疗决定前寻求持证的合法医生的建议，因自行使用药物以及治疗方式带来的不良后果，亮健康平台及主体不承担相应责任。
`